<template>
  <div :style="sparkleStyle()" class="sparkle" v-for="sparkle in sparkles" :key="sparkle.id">
      <div :style="divStyle()"></div>
  </div>
</template>

<script>
    const randomRange = ( min, max ) => {
        min = Math.ceil( min );
        max = Math.floor( max );
        return Math.floor( Math.random() * ( max - min + 1 ) ) + min;
    }
    // import { ref } from 'vue';
    export default {
    props: {
        members: {
        type: Array,
        required: true,
        },
    },
    methods : {
        sparkleStyle : function(){

            let top = randomRange( 0, 100 );
            let left = randomRange( 0, 100 );

        let size = `top:${ top }vh;left:${ left }vw;`;

        return size;
        },
        divStyle : function(){

            let height = randomRange( 5, 15 );

        let size = `height:${ height }vh;width:${ height }vh;`;

        return size;
        },
    },
    computed: {
        sparkles() {
        let members = this.members,
            length = members.length;

        return length;
        },
    },
    }
</script>

<style>
    @keyframes spakle {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes sparkleMove {
        0% {
            top: 0;
            left: 0;
            transform: scale(1.25);
        }
        25% {
            left: 1rem;
        }
        33% {
            top: 1rem;
        }
        50% {
            left: 0;
        }
        66% {
            top: .5rem;
            transform: scale(0.75);
        }
        75% {
            left: 1rem;
        }
        100% {
            top: 0;
            left: 0;
            transform: scale(1.25);
        }
    }
    .sparkle {
        animation: spakle 2s;
        opacity: 1;
        position: fixed;
        z-index: -1;
        -webkit-filter: drop-shadow( 5px 2px #fff );
        -moz-filter: drop-shadow( 5px 2px #fff );
        -ms-filter: drop-shadow( 5px 2px #fff );
        -o-filter: drop-shadow( 5px 2px #fff );
        filter: drop-shadow( 5px 2px #fff );
    }
    .sparkle div {
        position: absolute;
        background: var(--color);
        animation: sparkleMove 30s infinite ease-in-out;
        /* opacity: .75; */
        width: 100%;
        height: 100%;
        -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 100"><path d="M76 50a76.65 76.65 0 00-34.16 39.79L38 100l-3.84-10.21A76.61 76.61 0 000 50a76.61 76.61 0 0034.16-39.79L38 0l3.84 10.21A76.65 76.65 0 0076 50z"/></svg>') center/contain no-repeat;
                mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 100"><path d="M76 50a76.65 76.65 0 00-34.16 39.79L38 100l-3.84-10.21A76.61 76.61 0 000 50a76.61 76.61 0 0034.16-39.79L38 0l3.84 10.21A76.65 76.65 0 0076 50z"/></svg>') center/contain no-repeat;
    }
</style>